var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.97 7.32004C15.59 2.92004 11.72 -0.349963 7.32004 0.0300366C2.92004 0.410037 -0.349963 4.28004 0.0300366 8.68004C0.410037 13.08 4.28004 16.35 8.68004 15.97C13.08 15.6 16.35 11.72 15.97 7.32004ZM9.00004 12C9.00004 12.55 8.55004 13 8.00004 13C7.45004 13 7.00004 12.55 7.00004 12V8.00004C7.00004 7.45004 7.45004 7.00004 8.00004 7.00004C8.55004 7.00004 9.00004 7.45004 9.00004 8.00004V12ZM8.00004 5.00004C7.45004 5.00004 7.00004 4.55004 7.00004 4.00004C7.00004 3.45004 7.45004 3.00004 8.00004 3.00004C8.55004 3.00004 9.00004 3.45004 9.00004 4.00004C9.00004 4.55004 8.55004 5.00004 8.00004 5.00004Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5f8c3921e06383a39fd801a2643c70a1.svg";
export { ForwardRef as ReactComponent };